import React from 'react';
import './style.scss';
import UQIcon from '../icon';

export interface UQButtonProps {
  type: 'primary' | 'secondary' | 'action';
  size?: 'small' | 'large';
  icon?: string;
  iconPosition?: 'left' | 'right';
  color?: string;
  children?: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean; 
}

const UQButton: React.FC<UQButtonProps> = ({
  type = 'primary',
  size = 'small',
  icon,
  iconPosition = 'right',
  color,
  children,
  onClick,
  disabled = false, 
}) => {
  return (
    <button
      className={`uq-button ${type} ${size} ${icon ? 'with-icon' : ''} ${iconPosition} ${color ? `${color}` : ''}${disabled ? ' disabled' : ''}`}
      onClick={onClick}
      disabled={disabled} 
    >
      {type === 'action' ? (
        <UQIcon icon="check" />
      ) : (
        <>
          {icon && iconPosition === 'left' && <UQIcon icon={icon} />}
          {children}
          {icon && iconPosition === 'right' && <UQIcon icon={icon} />}
        </>
      )}
    </button>
  );
};

export default UQButton;
